export const ADVERTISINGS_FETCH      = Symbol.for('advertising.list');
export const ADVERTISINGS_ORDERBY    = Symbol.for('advertising.orderby');
export const ADVERTISINGS_FILTER     = Symbol.for('advertising.filter');
export const ADVERTISINGS_PAGINATION = Symbol.for('advertising.pagination');
export const ADVERTISING_FETCH       = Symbol.for('advertising.get');
export const ADVERTISING_INSERT      = Symbol.for('advertising.insert');
export const ADVERTISING_DELETE      = Symbol.for('advertising.delete');
export const ADVERTISING_UPDATE      = Symbol.for('advertising.update');
